module.exports = __webpack_public_path__ + "static/media/EmptyBox.48ad3cf0.png";